import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchCategoryService {
  private selectedCategorySignal = signal<string>('All');
  
  // Public getter for the signal
  get selectedCategory() {
    return this.selectedCategorySignal;
  }
  
  // Method to update the selected category
  setSelectedCategory(category: string): void {
    this.selectedCategorySignal.set(category);
  }
  
  // Method to get the current category value
  getCurrentCategory(): string {
    return this.selectedCategorySignal();
  }
}
